import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getDoctors } from "../../actions/userActions/doctorAction";
import { getCities } from "../../actions/userActions/cityAction";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import SearchInput from "../subComponents/search/SearchInput";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import { DEFAULT_PAGE, DEFAULT_SEARCH, DEFAULT_CITY, DEFAULT_PAGE_SIZE } from '../../Constatns';
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import Heading6Regular from "../designSystem/Heading6Regular";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import CustomCitySelect from "../subComponents/select/CustomCitySearchselect";
import { PERMISSIONS } from "../../Permissions";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import GenericFilter, { FilterBar } from "../subComponents/Filter/GenericFilters";
import CustomFilterSelect from "../designSystem/CustomFilterSelect";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";

function Doctors() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const getInitialPage = () => parseInt(localStorage.getItem('doctors_page')) || DEFAULT_PAGE;
  const getInitialSearch = () => localStorage.getItem('doctors_search') || DEFAULT_SEARCH;
  const getInitialCity = () => parseInt(localStorage.getItem('doctors_city')) || DEFAULT_CITY;
  const getInitialPageSize = () => parseInt(localStorage.getItem('doctors_pageSize')) || DEFAULT_PAGE_SIZE;
  const [itemsPerPage, setItemsPerPage] = useState(getInitialPageSize());
  const [selectedCity, setSelectedCity] = useState(getInitialCity());
  const [currentPage, setCurrentPage] = useState(getInitialPage());
  const [doctorsData, setDoctorData] = useState([]);
  const [citiesLoaded, setCitiesLoaded] = useState(false);
  const [cityFilters] = useState({ textSearch: "", countryId: "1" });
  const [isReady, setIsReady] = useState(false);
  const [isFirstMount, setIsFirstMount] = useState(true);

  const [filters, setFilters] = useState({ textSearch: getInitialSearch() });
  const [selected, setSelected] = useState({ textSearch: getInitialSearch() });
  const [showFilters, setShowFilters] = useState(false);

  const doctors = useSelector((state) => state.doctors_reducer.doctors);
  const allCities = useSelector((state) => state.cities_reducer.cities);
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const totalPages = doctors?.totalPages || 0;
  const totalItems = doctors?.totalCount || 0;

  const isDoctorsLoading = useSelector((state) => state.doctors_reducer.isDoctorsLoading);
  const isCitiesLoading = useSelector((state) => state.cities_reducer.isCitiesLoading);
  const isLoading = isDoctorsLoading || isCitiesLoading;
  const cityBody = {
    filter: cityFilters,
    pageNumber: -1,
    pageSize: 0,
  };

  const getCityIdByNameOrId = useCallback((cityValue) => {
    if (!cityValue) return DEFAULT_CITY;
    if (!isNaN(parseInt(cityValue))) return parseInt(cityValue);
    if (!allCities?.result || !allCities.result[0]?.cities) return DEFAULT_CITY;

   const cityObj = allCities.result[0]?.cities.find(
      city => city.name.toLowerCase() === cityValue.toLowerCase()
    );

    return cityObj?.id || DEFAULT_CITY;
  }, [allCities]);

  const getCityNameById = useCallback((cityId) => {
if (!cityId || !allCities?.result || !allCities.result[0]?.cities) return "";
    const cityObj = allCities.result[0]?.cities.find(city => city.id === parseInt(cityId));
    return cityObj?.name || "";
  }, [allCities]);
  useEffect(() => {
    if (isFirstMount) {
      if (!location.state?.returnToDoctor && !location.state?.fromDoctor) {
        localStorage.removeItem('doctors_page');
        localStorage.removeItem('doctors_search');
        localStorage.removeItem('doctors_city');
        localStorage.removeItem('doctors_pageSize');
      }
      setIsFirstMount(false);
    }
  }, [isFirstMount, location]);

  useEffect(() => {
    const sessionId = Math.random().toString(36).substring(2, 15);
    localStorage.setItem('doctors_session_id', sessionId);

    return () => {
      if (localStorage.getItem('doctors_session_id') === sessionId) {
        localStorage.removeItem('doctors_page');
        localStorage.removeItem('doctors_search');
        localStorage.removeItem('doctors_city');
        localStorage.removeItem('doctors_pageSize');
        localStorage.removeItem('doctors_session_id');
      }
    };
  }, []);
  useEffect(() => {
    dispatch(getCities(cityBody)).then(() => setCitiesLoaded(true));
  }, []);
  useEffect(() => {
    if (!citiesLoaded) return;

    let newPage = currentPage;
    let newSearch = filters.textSearch;
    let newCityId = selectedCity;
    let newPageSize = itemsPerPage;
    let paramsChanged = false;

    if (location.state?.returnToDoctor || location.state?.fromDoctor) {
      if (location.state.page && newPage !== location.state.page) {
        newPage = location.state.page;
        localStorage.setItem('doctors_page', newPage.toString());
        paramsChanged = true;
      }

      if (location.state.search && newSearch !== location.state.search) {
        newSearch = location.state.search;
        localStorage.setItem('doctors_search', newSearch);
        paramsChanged = true;
      }

      if (location.state.city && newCityId !== location.state.city) {
        newCityId = location.state.city;
        localStorage.setItem('doctors_city', newCityId.toString());
        paramsChanged = true;
      }

      if (location.state.pageSize && newPageSize !== location.state.pageSize) {
        newPageSize = location.state.pageSize;
        localStorage.setItem('doctors_pageSize', newPageSize.toString());
        paramsChanged = true;
      }
    } else {
      const queryParams = new URLSearchParams(location.search);

      const pageParam = queryParams.get('page');
      if (pageParam && newPage !== parseInt(pageParam)) {
        newPage = parseInt(pageParam);
        paramsChanged = true;
      }

      const searchParam = queryParams.get('search');
      if (searchParam && newSearch !== searchParam) {
        newSearch = searchParam;
        paramsChanged = true;
      }

      const cityParam = queryParams.get('city');
      if (cityParam) {
        const resolvedCityId = getCityIdByNameOrId(cityParam);
        if (newCityId !== resolvedCityId) {
          newCityId = resolvedCityId;
          paramsChanged = true;
        }
      }

      const pageSizeParam = queryParams.get('pageSize');
      if (pageSizeParam && newPageSize !== parseInt(pageSizeParam)) {
        newPageSize = parseInt(pageSizeParam);
        paramsChanged = true;
      }

      if (isFirstMount && !location.state) {
        if (pageParam) localStorage.setItem('doctors_page', newPage.toString());
        if (searchParam) localStorage.setItem('doctors_search', newSearch);
        if (cityParam) localStorage.setItem('doctors_city', newCityId.toString());
        if (pageSizeParam) localStorage.setItem('doctors_pageSize', newPageSize.toString());
      }
    }

    if (paramsChanged) {
      setCurrentPage(newPage);
      setFilters({ ...filters, textSearch: newSearch });
      setSelected({ ...selected, textSearch: newSearch });
      setSelectedCity(newCityId);
      setItemsPerPage(newPageSize);
    }

    setIsReady(true);
  }, [location, citiesLoaded, allCities, getCityIdByNameOrId, isFirstMount]);
  useEffect(() => {
    if (!isReady) return;

    const doctorBody = {
      pageNumber: currentPage,
      pageSize: itemsPerPage,
      textSearch: filters.textSearch,
      cityId: selectedCity,
      practiceLocationId: 0
    };

    dispatch(getDoctors(doctorBody));

    const params = new URLSearchParams();
    params.set('page', currentPage);
    params.set('pageSize', itemsPerPage);
    if (filters.textSearch) params.set('search', filters.textSearch);

    const cityName = getCityNameById(selectedCity);
    if (cityName) {
      params.set('city', cityName);
    } else {
      params.set('city', selectedCity);
    }

    const newSearch = params.toString() ? `?${params.toString()}` : '';

    if (location.search !== newSearch) {
      history.replace({
        pathname: location.pathname,
        search: newSearch
      });
    }
  }, [selectedCity, currentPage, itemsPerPage, filters, isReady, getCityNameById]);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleClearAllFilters = () => {
    setSelectedCity(1);
  };
  const handleItemsPerPageChange = (value) => {
    const doctorBody = {
      pageNumber: 1,
      pageSize: value,
      textSearch: filters.textSearch,
      cityId: selectedCity,
      practiceLocationId: 0
    };

    dispatch(getDoctors(doctorBody));
    setItemsPerPage(value);
    setCurrentPage(1);
    localStorage.setItem('doctors_pageSize', value.toString());
  };
  const handleAddDoctorClick = () => {
    history.push({
      pathname: '/admin/AddDoctors',
      state: {
        fromDoctor: true,
        page: currentPage,
        search: filters.textSearch,
        city: selectedCity,
        pageSize: itemsPerPage
      }
    });
  };

  const handleEditDoctor = (row) => {
    history.push({
      pathname: '/admin/UpdateDoctors',
      doctors: { row },
      id: row.id,
      state: {
        fromDoctor: true,
        page: currentPage,
        search: filters.textSearch,
        city: selectedCity,
        pageSize: itemsPerPage
      }
    });
  };

  const handleCityChange = (event) => {
    const newCityId = event.target.value;
    setSelectedCity(newCityId);
    localStorage.setItem('doctors_city', newCityId.toString());
  };

  const handleSearch = (e) => {
    const newValue = e.target.value;
    setSelected({ ...selected, textSearch: newValue });

    if (newValue.length >= 1) {
      setTimeout(() => {
        setFilters({ ...filters, textSearch: newValue });
        localStorage.setItem('doctors_search', newValue);
      }, 500);
    }

    if (newValue === '') {
      setFilters({ ...filters, textSearch: newValue });
      localStorage.removeItem('doctors_search');
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem('doctors_page', page.toString());
  };

  useEffect(() => {
    const doctorData = doctors && doctors.result?.[0]?.doctors || [];
    const DoctorData = doctorData?.map((doctor) => ({
      ...doctor,
      status: (
        <span className={doctor.active ? "status-badge-active" : "status-badge-inactive"}>
          {doctor.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setDoctorData(DoctorData);
  }, [doctors]);

  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("specialization")}`, accessor: "specializationName" },
    { label: `${t("designation")}`, accessor: "rankName" },
    { label: `${t("status")}`, accessor: "status" },
  ];

  const getCityOptions = () => {
     if (allCities === "isLoading" || !allCities?.result?.[0]?.cities) {
      return [];
    }

    return allCities.result[0].cities
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(city => ({
        id: city.id,
        name: city.name
      }));
  };

  const cityOptions = getCityOptions();
  const actions = [
    {
      label: 'Edit Doctor',
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: 'CanUpdateDoctor',
      handler: handleEditDoctor,
    },
  ];

  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading} />
        <div className="main-container">
          <div className="content-wrapper p-0">
            <div className="" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 16px' }}>
              <SearchInput
                placeholder="Search"
                onChange={handleSearch}
                value={selected.textSearch}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ minWidth: '80px', marginRight: '10px' }}>
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
                <div style={{marginRight: "12px"}}>
                <GenericFilter
                  showFilters={showFilters}
                  toggleFilters={toggleFilters}
                  />
                  </div>
                {permissions && permissions.includes(PERMISSIONS.CAN_ADD_DOCTOR) && (
                  <CustomButton text={t("addNew")} onClick={handleAddDoctorClick} />
                )}
              </div>
            </div>

            <FilterBar
              showFilters={showFilters}
              onClearAll={handleClearAllFilters}
            >
              <CustomFilterSelect
                label={t("city")}
                value={selectedCity}
                onChange={handleCityChange}
                options={cityOptions} // Your cities array
                disabled={!citiesLoaded}
                width="220px"
                searchable={true}
                searchPlaceholder="Search cities..."
                noDataText="No cities available"
              />
            </FilterBar>
          </div>
          <DynamicTable
            data={doctorsData}
            columns={columns}
            permissions={permissions}
            actions={actions}
            thIcon={thIcon}
            showPagination={totalItems > 0}
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>
      </div>
    </>
  );
}

export default Doctors;